import { SystemEvent, SystemEventLevel } from 'bernie-logger';

export const STORE_EVENTS = {
  BFF_SEARCH_POOPED: new SystemEvent(SystemEventLevel.ERROR, 'BFF_SEARCH_POOD'),
  SEARCH_CACHE_ERROR: new SystemEvent(SystemEventLevel.ERROR, 'SEARCH_CACHE_ERROR'),
  LOAD_SEARCH_CACHE_ERROR: new SystemEvent(SystemEventLevel.ERROR, 'LOAD_SEARCH_CACHE_ERROR'),
  SEARCH_RETURNED_FROM_CACHE: new SystemEvent(SystemEventLevel.INFO, 'SEARCH_RETURNED_FROM_CACHE'),
  SHORTLIST_FETCH_FAILED: new SystemEvent(SystemEventLevel.ERROR, 'SHORTLIST_FETCH_FAILED'),
  SHORTLIST_REMOVE_FAILED: new SystemEvent(SystemEventLevel.ERROR, 'SHORTLIST_REMOVE_FAILED'),
  SHORTLIST_ADD_FAILED: new SystemEvent(SystemEventLevel.ERROR, 'SHORTLIST_ADD_FAILED'),
  DETAIL_BASIC_FETCH_FAILED: new SystemEvent(SystemEventLevel.ERROR, 'DETAIL_BASIC_FETCH_FAILED'),
  DETAIL_AVAILABILITY_FETCH_FAILED: new SystemEvent(SystemEventLevel.ERROR, 'DETAIL_AVAILABILITY_FETCH_FAILED'),
  DETAIL_REVIEWS_FETCH_FAILED: new SystemEvent(SystemEventLevel.ERROR, 'DETAIL_REVIEWS_FETCH_FAILED'),
  DETAIL_OFFERS_FETCH_FAILED: new SystemEvent(SystemEventLevel.ERROR, 'DETAIL_OFFERS_FETCH_FAILED'),
  DETAIL_OFFER_FETCH_FAILED: new SystemEvent(SystemEventLevel.ERROR, 'DETAIL_OFFER_FETCH_FAILED'),
  DETAIL_RECOMMENDATION_FETCH_FAILED: new SystemEvent(SystemEventLevel.ERROR, 'DETAIL_RECOMMENDATION_FETCH_FAILED'),
  CREATE_TRIP_FAILURE: new SystemEvent(SystemEventLevel.ERROR, 'CREATE_TRIP_FAILURE'),
  TRIP_ID_NOT_RETURNED: new SystemEvent(SystemEventLevel.ERROR, 'TRIP_ID_NOT_RETURNED'),
  REVIEW_UPVOTE_FAILED: new SystemEvent(SystemEventLevel.ERROR, 'REVIEW_UPVOTE_FAILED'),
  SEO_CONTENT_FETCH_FAILED: new SystemEvent(SystemEventLevel.ERROR, 'SEO_CONTENT_FETCH_FAILED'),
  MARKETING_INFO_PARSING_FAILED: new SystemEvent(SystemEventLevel.ERROR, 'MARKETING_INFO_PARSING_FAILED'),
  DETAIL_OFFER_FILTER_CLICK_ERROR: new SystemEvent(SystemEventLevel.ERROR, 'DETAIL_OFFER_FILTER_CLICK_ERROR'),
  USER_GEO_LOCATION_FETCH_ERROR: new SystemEvent(SystemEventLevel.ERROR, 'USER_GEO_LOCATION_FETCH_ERROR'),
  DETAIL_OFFER_MEAL_INCLUSIONS_CLICK_ERROR: new SystemEvent(
    SystemEventLevel.ERROR,
    'DETAIL_OFFER_MEAL_INCLUSIONS_CLICK_ERROR'
  ),
  DETAIL_OFFER_FILTER_TICKET_DATA_PARSE_ERROR: new SystemEvent(
    SystemEventLevel.ERROR,
    'DETAIL_OFFER_FILTER_TICKET_DATA_PARSE_ERROR'
  ),
  DESTINATION_QUERY_FETCHED: new SystemEvent(SystemEventLevel.INFO, 'DESTINATION_QUERY_FETCHED'),
  ACTIVITY_SEARCH_STORE_INITIATED: new SystemEvent(SystemEventLevel.INFO, 'ACTIVITY_SEARCH_STORE_INITIATED'),
  INVALID_DATE_FORMAT: new SystemEvent(SystemEventLevel.WARN, 'INVALID_DATE_FORMAT'),
  SANITIZE_REQUEST_NO_REQUEST: new SystemEvent(SystemEventLevel.ERROR, 'SANITIZE_REQUEST_NO_REQUEST'),
  SANITIZE_REQUEST_UNKNOWN_FAILURE: new SystemEvent(SystemEventLevel.CRITICAL, 'SANITIZE_REQUEST_FAILURE'),
  SANITIZE_QUERY_CASE_LOGGER: new SystemEvent(SystemEventLevel.WARN, 'SANITIZE_QUERY_CASE_LOGGER')
};
